module.exports = __webpack_public_path__ + "img/20220328_142011.20b90bbc.jpg";